export default "__VITE_ASSET__5KaFzzhy__"